import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import alert_mixin from '@/utils/mixins/alert_mixin';


export default {
  name:'EnquiryLandingPage',
  mixins: [alert_mixin],
  components:{
      AICampusFooter,
      navbar
  },
  data: () => ({ enquiry_form_id: '' }),
  mounted(){
      this.get_enquiry_form_id_from_session();
  },

  methods: {
      get_enquiry_form_id_from_session() {
        this.enquiry_form_id = localStorage.getItem('enquiry_form_id');
      }
  }
}